import React from "react";
import Card from "../../components/Card/Card";
import { FaTools, FaPaperPlane } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Assuming you use react-router
import "../../App.css";

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="card-wrapper">
        <main className="card-container">
          <Card
            icon={<FaTools />}
            title="Harvest"
            description="Web harvest pulls data from websites and adds leads to DB"
            buttonLabel="Configure"
            buttonHref="https://topline.speedstack.tech/data_harvest"
          />
          <Card
            icon={<FaPaperPlane />}
            title="ReachOut"
            description="Manage your Email and WhatsApp Campaigns"
            buttonLabel="Open"
            onClick={() => navigate("/reachout")}
          />
        </main>
      </div>
    </div>
  );
}

export default LandingPage;
